import StoreCreditAPI from '@/app/apis/main/store-credit/store-credit-api.js';

export default {
	/**
	* @return {object}
	*/
	async getStoreCredit()  {
		return StoreCreditAPI.getStoreCredit();
	},

	/**
	* @param petId
	* @param chargeDetails
	* @return {object}
	*/
	async chargeStoreCredit(petId, chargeDetails) {
		return StoreCreditAPI.chargeStoreCredit(petId, chargeDetails);
	}
}